import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import parse from 'html-react-parser';

import aktifDonem from '../../services/aktifDonem';

import logo from '../../assets/img/odu-yatay.png'
import doku from '../../assets/img/bd-doku2.png'

import { BsArrowRightCircle, BsFillExclamationTriangleFill } from "react-icons/bs";




const Home = () => {


    const [donem, setDonem] = useState()

    useEffect(() => {
        const fecthData = async () => {
            const result = await aktifDonem()
            setDonem(result)
            document.title = "Sosyal Ve Beşeri Bilimler Araştırmaları Etik Kurulu"
        }
        fecthData()
    }, []);


    return (

        <>
            {
                donem ? (
                    <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                        <div className='mx-auto w-full max-w-4xl pt-11'>
                            <div>
                                <img src={logo} alt='Ordu Üniversitesi' className='mb-6 h-20 mx-auto' />
                            </div>
                            <div className='text-center font-semibold text-slate-500 text-lg'>
                                SOSYAL VE BEŞERİ BİLİMLER ARAŞTIRMALARI ETİK KURULU
                            </div>
                            <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 text-slate-500 space-y-3 text-sm indent-8 text-justify'>
                                {
                                    parse(donem.donemAciklama)
                                }
                            </div>

                            <div className='text-center '>
                                <Link to="/basvuru-formu">
                                    <button
                                        className='bg-slate-500 border-slate-400 border hover:bg-slate-400 inline-flex justify-between items-center gap-x-4 text-white text-sm px-4 py-2 rounded-md outline-transparent outline-offset-2 outline-dashed focus:outline-slate-400 focus:outline-1'
                                    >
                                        Başvuruyu Başlat
                                        <span className='text-lg'>
                                            <BsArrowRightCircle />
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>

                    </div>
                ) : (
                    donem === false ? (
                        <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                            <div className='mx-auto w-full max-w-4xl pt-11'>
                                <div>
                                    <img src={logo} alt='Ordu Üniversitesi' className='mb-6 h-20 mx-auto' />
                                </div>
                                <div className='text-center font-semibold text-slate-500 text-lg'>
                                    SOSYAL VE BEŞERİ BİLİMLER ARAŞTIRMALARI ETİK KURULU
                                </div>


                                <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 gap-y-4 text-slate-500 bg-slate-200 text-sm flex flex-col justify-center items-center'>
                                    <BsFillExclamationTriangleFill className='text-3xl text-red-600' />
                                    <div className='text-slate-700 font-medium text-lg'>
                                        Üzgünüz!
                                    </div>
                                    <div>
                                       Sosyal Ve Beşeri Bilimler Araştırmaları Etik Kurulu başvuruları için aktif başvuru dönemi bulunamamıştır.
                                    </div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                            <div className='mx-auto w-full max-w-4xl pt-11'>
                                <div role="status" className=" animate-pulse">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                                    <div className="h-2 bg-gray-200 rounded-full  max-w-[360px] mb-2.5"></div>
                                    <div className="h-2 bg-gray-200 rounded-full  mb-2.5"></div>
                                    <div className="h-2 bg-gray-200 rounded-full  max-w-[330px] mb-2.5"></div>
                                    <div className="h-2 bg-gray-200 rounded-full  max-w-[300px] mb-2.5"></div>
                                    <div className="h-2 bg-gray-200 rounded-full  max-w-[360px]"></div>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )

                )
            }
        </>
    );
}

export default Home;
